import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import { RouterLink, useRoute } from 'vue-router';

import Breadcrumb from 'primevue/breadcrumb';

import { useBreadcrumbs } from '../composables/useBreadcrumbs';


export default /*@__PURE__*/_defineComponent({
  __name: 'AppBreadcrumbs',
  setup(__props) {

const { handleBreadcrumbs } = useBreadcrumbs();

return (_ctx: any,_cache: any) => {
  return (_ctx.$route.meta.breadcrumb)
    ? (_openBlock(), _createBlock(_unref(Breadcrumb), {
        key: 0,
        home: {
      icon: 'pi pi-home',
      url: '/',
    },
        model: _unref(handleBreadcrumbs)()
      }, {
        item: _withCtx(({ item }) => [
          _createVNode(_unref(RouterLink), {
            class: "text-gray-600",
            to: item.url
          }, {
            default: _withCtx(() => [
              _createElementVNode("i", {
                class: _normalizeClass(item.icon)
              }, null, 2),
              _createTextVNode(" " + _toDisplayString(item.label), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ]),
        separator: _withCtx(() => _cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "pi pi-chevron-right" }, null, -1)
        ])),
        _: 1
      }, 8, ["model"]))
    : _createCommentVNode("", true)
}
}

})